// Role application questions. `id` is the stable question identifier: the
// RoleChangeRequest.applicationAnswers key the answer is stored under on the
// server (never the question text). Order = display order. Labels come from
// the roleChangeRequest catalogue; `fallback` is the English text.
export const ROLE_APPLICATION_QUESTIONS = Object.freeze([
  { id: "aboutYourself", labelKey: "aboutYourself", fallback: "Tell us about yourself.", required: true },
  { id: "experience", labelKey: "applicationExperience", fallback: "Experience / Relevant Experience" },
  { id: "motivation", labelKey: "applicationMotivation", fallback: "Why do you want to become a Seller or Provider on Elakay?" },
  { id: "longTermGoals", labelKey: "longTermGoals", fallback: "What are your long-term goals?" },
  { id: "goals", labelKey: "applicationGoals", fallback: "What do you expect from Elakay?" },
  { id: "communityContribution", labelKey: "communityContribution", fallback: "What do you think you can contribute to the Elakay community?" },
  { id: "localCommunityImpact", labelKey: "localCommunityImpact", fallback: "How will you help your community?" },
  { id: "additionalInformation", labelKey: "additionalInformation", fallback: "Additional information you'd like to share." },
]);

export const REQUIRED_APPLICATION_QUESTION_IDS = ROLE_APPLICATION_QUESTIONS.filter((question) => question.required).map((question) => question.id);

export const roleApplicationQuestion = (id) => ROLE_APPLICATION_QUESTIONS.find((question) => question.id === id) || null;
